import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'validDate' })
export class ValidDatePipe implements PipeTransform {
  transform(value: any): any {
    if (!value) return null;
    const d = new Date(value);
    if (isNaN(d.getTime()) || d.getFullYear() <= 1) return null;
    return value;
  }
}
